import { getFeatureFlags } from '@chegg/wtf-components'

export interface AllocationMap {
  [layer: string]: string
}

interface FeatureFlags {
  allocationMap?: AllocationMap
}

let ff: FeatureFlags

export const getMemoizedFeatureFlags = (): FeatureFlags => {
  ff = ff || getFeatureFlags()
  return ff
}



// WEBPACK FOOTER //
// ./src/state/analytics/utils/getMemoizedFeatureFlags.ts